import Vue from 'vue';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/theme.css';
// import 'element-ui/lib/theme-chalk/display.css';
import i18n from '@/i18n';

// Element UI takes its strings from our own catalogs (the `el` key of each
// locale file), so it follows the language resolved from the URL.
Vue.use(Element, {
	i18n: (key, value) => i18n.t(key, value),
});

// Override default components from Element UI
import ElCard from '@/overrides/ElCard.vue';
import ElDrawer from '@/overrides/ElDrawer.vue';
import ElPopover from '@/overrides/ElPopover.vue';
import ElAlert from '@/overrides/ElAlert.vue';
import ElDialog from '@/overrides/ElDialog.vue';
import ElInput from '@/overrides/ElInput.vue';
import ElFormItem from '@/overrides/ElFormItem.vue';
import ElTabPane from '@/overrides/ElTabPane.vue';
import ElMenuItem from '@/overrides/ElMenuItem.vue';
import ElLink from '@/overrides/ElLink.vue';
import ElButton from '@/overrides/ElButton.vue';
Vue.component('ElCard', ElCard);
Vue.component('ElDrawer', ElDrawer);
Vue.component('ElPopover', ElPopover);
Vue.component('ElAlert', ElAlert);
Vue.component('ElDialog', ElDialog);
Vue.component('ElInput', ElInput);
Vue.component('ElFormItem', ElFormItem);
Vue.component('ElTabPane', ElTabPane);
Vue.component('ElMenuItem', ElMenuItem);
Vue.component('ElLink', ElLink);
Vue.component('ElButton', ElButton);
